<template lang="pug">
    .user-payout
      SectionHeader(:header="header")
  
      .action__body
        .action__section
          .action__grid
            .action__form-field(v-for="(item, i) of items" :key="i")
              InputSmart(:item="item")
  
        .action__bottom
          Button(is-primary @click="onCheckButtonClick") Подтвердить
  
  </template>
  
  <script>
  import { mapActions } from 'vuex'
  import InputSmart from '@/components/InputSmart/InputSmart'
  import SectionHeader from '@/components/SectionHeader/SectionHeader'
  
  export default {
    name: 'UserPayout',
  
    components: {
      InputSmart,
      SectionHeader,
    },
  
    data: () => ({
      items: {
        playerId: {
          title: 'ID игрока',
          value: null,
          type: 'number',
          placeholder: 'Введите ID',
        },
      },
    }),
  
    computed: {
      gameName() {
        return this.$route.params.section
      },
  
      header() {
        return {
          title: `Подтверждение почты`,
          game: this.gameName,
        }
      },
    },
  
    created() {
      this.$forceUpdate()
    },
  
    methods: {
      ...mapActions('modal', ['showModal']),
  
      async onCheckButtonClick() {
        this.$loading.start()
  
        try {
          const playerId = this.items.playerId.value
  
          const { data } = await this.$axios.post(`/admin/user/${playerId}/email/verify`)
  
          if (data.data) {
            this.showModal({
              component: 'ModalMessage',
              data: {
                type: 'success',
                title: 'Успех',
                text: 'Почта подтверждена!',
              },
            })
          }
        } catch (e) {
          this.$error.handle(e)
        }
  
        this.$loading.finish()
      }
    },
  }
  </script>
  
  <style lang="scss">
  </style>
  